import Compress from 'brotli-wasm'

export const compressHtml = async (htmlString) => {
    const compressed = (await Compress).compress(
        new TextEncoder().encode(htmlString)
    );
    const base64String = btoa(String.fromCharCode(...compressed));
    return base64String;
};